<template>
        <div  :id="id"/>
</template>

<script>
    import { Chart } from '@antv/g2';


    export default {
        name: "areaChart",
        data(){
            return{
               // data:
            }
        },
        props:["data","id" ],
        watch:{
            data:function(newVal,oldVal){
                this.data = newVal;
                // console.log("引入了",this.data);
                this.changChats(newVal)
            },
            id:function(newVal,oldVal){
                this.id = newVal;
                this.changChats(newVal)
            },
        },
        methods:{
            changChats(data){
                // console.log(data);
                this.chart.clear()
                this.chart.source(data)
                this.chart.interval().position('value').color('type')
                    .tooltip('type*value*num', (type,value, num) => {
                        return {
                            type:type,
                            num:num,
                            value: (value * 100).toFixed(2) + '%'
                        };
                    }).label('value', {
                            content: (data) => {
                                    return `${data.type}`;

                                    // ${(data.value * 100).toFixed(2)}%
                            },
                    }).adjust('stack')
                this.chart.interaction('element-active');
                this.chart.render();
            },
            newCharts(){
                this.chart = new Chart({
                    container: this.id,
                    autoFit: true,
                    height: 500,
                    padding:[0,40,40,40]
                });

                this.chart.coordinate('theta', {
                    radius: 0.6,
                });

                this.chart.data(this.data);

                this.chart.scale('value' , {
                    formatter: (val) => {
                        val = (val * 100).toFixed(2) + '%';
                        return val;
                    },
                });

                this.chart.tooltip({
                    showTitle: true,
                    showMarkers: false,
                        itemTpl:`<div style="height: 60px"><p>{type}:</p> <span style="position: relative;">{num}({value})</span></div>`
                });

                // this.chart
                //     .interval()
                //     .position('value')
                //     .color('type')
                //     .label('value', {
                //         content: (data) => {
                //             return `${data.type}: ${(data.value * 100).toFixed(2)}%`;
                //         },
                //     })
                //     .adjust('stack');

              this.chart.legend({
                position: 'bottom',
                itemHeight: 30,
              });
                this.chart.interval().position('value').color('type')
                    .tooltip('type*value*num', (type,value, num) => {
                        return {
                            type:type,
                            num:num,
                            value: (value * 100).toFixed(2) + '%'
                        };
                    }).label('value', {
                            content: (data) => {
                                    return `${data.type}`;

                                    // ${(data.value * 100).toFixed(2)}%
                            },
                    }).adjust('stack')
                this.chart.interaction('element-active');
                // this.chart.render();
            }
        },
        mounted() {
            this.newCharts()
            // this.chart.render();
        }
    }
</script>

<style scoped>

</style>
